// extracted by mini-css-extract-plugin
export default {"Answer":"Answers_Answer__P-6ZJ","AnswerItemsContainer":"Answers_AnswerItemsContainer__0hfqo"};